/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarifDto } from './TarifDto';
import {
    TarifDtoFromJSON,
    TarifDtoFromJSONTyped,
    TarifDtoToJSON,
    TarifDtoToJSONTyped,
} from './TarifDto';

/**
 * Détail d'une commission de garantie.
 * @export
 * @interface CommissionGarantieDetailDto
 */
export interface CommissionGarantieDetailDto {
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    garantieTunnelId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    natureRemunerationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    natureRemunerationLibelle?: string | null;
    /**
     * 
     * @type {TarifDto}
     * @memberof CommissionGarantieDetailDto
     */
    tarif?: TarifDto;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    beneficiairePersonneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionGarantieDetailDto
     */
    beneficiaireNom?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommissionGarantieDetailDto
     */
    isCourtierConnecte?: boolean;
}

/**
 * Check if a given object implements the CommissionGarantieDetailDto interface.
 */
export function instanceOfCommissionGarantieDetailDto(value: object): value is CommissionGarantieDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CommissionGarantieDetailDtoFromJSON(json: any): CommissionGarantieDetailDto {
    return CommissionGarantieDetailDtoFromJSONTyped(json, false);
}

export function CommissionGarantieDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionGarantieDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'garantieTunnelId': json['garantieTunnelId'] == null ? undefined : json['garantieTunnelId'],
        'natureRemunerationId': json['natureRemunerationId'] == null ? undefined : json['natureRemunerationId'],
        'natureRemunerationLibelle': json['natureRemunerationLibelle'] == null ? undefined : json['natureRemunerationLibelle'],
        'tarif': json['tarif'] == null ? undefined : TarifDtoFromJSON(json['tarif']),
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'beneficiairePersonneId': json['beneficiairePersonneId'] == null ? undefined : json['beneficiairePersonneId'],
        'beneficiaireNom': json['beneficiaireNom'] == null ? undefined : json['beneficiaireNom'],
        'isCourtierConnecte': json['isCourtierConnecte'] == null ? undefined : json['isCourtierConnecte'],
    };
}

export function CommissionGarantieDetailDtoToJSON(json: any): CommissionGarantieDetailDto {
    return CommissionGarantieDetailDtoToJSONTyped(json, false);
}

export function CommissionGarantieDetailDtoToJSONTyped(value?: CommissionGarantieDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'garantieTunnelId': value['garantieTunnelId'],
        'natureRemunerationId': value['natureRemunerationId'],
        'natureRemunerationLibelle': value['natureRemunerationLibelle'],
        'tarif': TarifDtoToJSON(value['tarif']),
        'compteBancaireId': value['compteBancaireId'],
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'beneficiaireNom': value['beneficiaireNom'],
        'isCourtierConnecte': value['isCourtierConnecte'],
    };
}

